import {Routes} from '@angular/router';

export const gasCashRoutes: Routes = [
  {
    path: 'gas.cash',
    loadComponent: () => import('./gas.cash.component').then(m => m.GasCashComponent),
    data: {title: '燃气费兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.lottery.cash',
        loadComponent: () => import('./add.lottery.cash/add.lottery.cash.component').then(m => m.AddLotteryCashComponent),
        data: { title: '燃气费抽奖兑付明细' },
      },
      {
        path: 'add.lottery.cash/:orderId',
        loadComponent: () => import('./add.lottery.cash/add.lottery.cash.component').then(m => m.AddLotteryCashComponent),
        data: { title: '燃气费抽奖兑付明细' },
      },
      {
        path: 'add.equity.cash',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '燃气费权益兑付明细' },
      },
      {
        path: 'add.equity.cash/:orderId',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '燃气费权益兑付明细' },
      },
    ]
  },
]
